module.exports = __webpack_public_path__ + "img/img_quick_book.590cce41.jpg";